import Auth from "./auth.js";
import _isEmpty from "lodash/isEmpty";
import { getUtmTags, getUserProperties } from "@/utils/userTrackingProperties";

export default {
    mixins: [Auth],
    methods: {
        $_accountValidation(userData = {}, accountExists = false) {
            if (accountExists) {
                this.$_handleEmailAuth(userData);
            } else {
                this.$notify({
                    group: "app-notifications",
                    type: "error",
                    text: "Wrong email/password. – Please try again.",
                    duration: 5000
                });
            }
        },
        $_handleSuccessfullAuth(user = {}) {
            this.$emit("auth-sucessfull", user);
            this.$store.dispatch("User/setToken", user.token);
            Cookies.set("token", user.token);
            const defaultRouteToGo = { name: "discover-landing" };
            if (this.useRouteHandler) {
                this.$_handleNextRoute(this.$route, defaultRouteToGo);
            }
        },
        $_signInTrackings(user = {}, method = "email") {
            const firstTrackingEvent = getUserProperties(
                {
                    utm_tags: getUtmTags(this.$route.query),
                    method,
                    userId: user.user_id
                },
                { ...user }
            );
            if (this.$route.meta.group == "nonfiction") {
                // analytics first user configuration
                if (!_isEmpty(analytics)) {
                    analytics.identify(user.user_id, firstTrackingEvent);
                    analytics.track("web_account_sign_in", firstTrackingEvent);
                }
            }
        }
    }
};
